export default "__VITE_ASSET__BVUlAS7a__"